import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../app/layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_gtm_dbd73ac8 from 'nuxt_plugin_gtm_dbd73ac8' // Source: ./gtm.js (mode: 'all')
import nuxt_plugin_router_2faddbae from 'nuxt_plugin_router_2faddbae' // Source: ./router.js (mode: 'all')
import nuxt_plugin_polyfill_154da826 from 'nuxt_plugin_polyfill_154da826' // Source: ../app/plugins/polyfill (mode: 'all')
import nuxt_plugin_common_721d56fc from 'nuxt_plugin_common_721d56fc' // Source: ../app/plugins/common (mode: 'all')
import nuxt_plugin_kernel_575d119a from 'nuxt_plugin_kernel_575d119a' // Source: ../app/plugins/kernel (mode: 'all')
import nuxt_plugin_injector_03ffdcaa from 'nuxt_plugin_injector_03ffdcaa' // Source: ../app/plugins/injector (mode: 'all')
import nuxt_plugin_dataStream_530df880 from 'nuxt_plugin_dataStream_530df880' // Source: ../app/plugins/dataStream (mode: 'all')
import nuxt_plugin_userAgent_fb3d1178 from 'nuxt_plugin_userAgent_fb3d1178' // Source: ../app/plugins/userAgent (mode: 'all')
import nuxt_plugin_adManager_7292b158 from 'nuxt_plugin_adManager_7292b158' // Source: ../app/plugins/adManager (mode: 'all')
import nuxt_plugin_vueScrollto_46a09977 from 'nuxt_plugin_vueScrollto_46a09977' // Source: ../app/plugins/vueScrollto (mode: 'all')
import nuxt_plugin_userinsight_d7933d94 from 'nuxt_plugin_userinsight_d7933d94' // Source: ../app/plugins/userinsight (mode: 'all')
import nuxt_plugin_revisionCheck_6bb7fb76 from 'nuxt_plugin_revisionCheck_6bb7fb76' // Source: ../app/plugins/revisionCheck (mode: 'all')
import nuxt_plugin_snapSlider_11929541 from 'nuxt_plugin_snapSlider_11929541' // Source: ../app/plugins/snapSlider (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":true,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"スナップスナップ - スクールフォト販売サイト","titleTemplate":"%s | スナップスナップ - スクールフォト販売サイト","htmlAttrs":{"lang":"ja"},"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"description","name":"description","content":"スナップスナップは、こどもたちの生き生きとした瞬間を『カタチ＝写真』にしてお届けするサービスです。"},{"hid":"keyword","name":"keyword","content":"スナップスナップ,snapsnap,イベント,撮影,プロカメラマン,写真,プリント,販売,学校,幼稚園,保育園,こども園"},{"hid":"read-aloud","name":"google","content":"nopagereadaloud"},{"hid":"og:site_name","property":"og:site_name","content":"スナップスナップ - スクールフォト販売サイト"},{"hid":"og:type","property":"og:type","content":"website"},{"hid":"og:url","property":"og:url","content":"https:\u002F\u002Fsnapsnap.jp"},{"hid":"og:title","property":"og:title","content":"スナップスナップ"},{"hid":"og:description","property":"og:description","content":"スナップスナップは、こどもたちの生き生きとした瞬間を『カタチ＝写真』にしてお届けするサービスです。"},{"hid":"og:image","property":"og:image","content":"https:\u002F\u002Fsnapsnap.jp\u002Fstatic\u002Fogp\u002Fsnapsnap.jpg"},{"hid":"google-site-verification","name":"google-site-verification","content":"sGhsU1TuK5lvTqLI9bVEuhCrjECnq_MX9IS6OGkCwqo"}],"link":[{"rel":"preconnect","href":"https:\u002F\u002Ffonts.googleapis.com"},{"rel":"preconnect","href":"https:\u002F\u002Ffonts.gstatic.com","crossorigin":"anonymous"},{"rel":"stylesheet","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss?family=Ubuntu:300,400,500,700"},{"rel":"shortcut icon","type":"image\u002Fx-icon","href":"\u002Fstatic\u002Ficon\u002Ffavicon.ico"},{"rel":"icon","type":"image\u002Fpng","href":"\u002Fstatic\u002Ficon\u002Fapple-touch-icon-180x180.png","sizes":"192x192"},{"rel":"apple-touch-icon","href":"\u002Fstatic\u002Ficon\u002Fapple-touch-icon.png"},{"rel":"apple-touch-icon","sizes":"57x57","href":"\u002Fstatic\u002Ficon\u002Fapple-touch-icon-57x57.png"},{"rel":"apple-touch-icon","sizes":"72x72","href":"\u002Fstatic\u002Ficon\u002Fapple-touch-icon-72x72.png"},{"rel":"apple-touch-icon","sizes":"76x76","href":"\u002Fstatic\u002Ficon\u002Fapple-touch-icon-76x76.png"},{"rel":"apple-touch-icon","sizes":"114x114","href":"\u002Fstatic\u002Ficon\u002Fapple-touch-icon-114x114.png"},{"rel":"apple-touch-icon","sizes":"120x120","href":"\u002Fstatic\u002Ficon\u002Fapple-touch-icon-120x120.png"},{"rel":"apple-touch-icon","sizes":"144x144","href":"\u002Fstatic\u002Ficon\u002Fapple-touch-icon-144x144.png"},{"rel":"apple-touch-icon","sizes":"152x152","href":"\u002Fstatic\u002Ficon\u002Fapple-touch-icon-152x152.png"},{"rel":"apple-touch-icon","sizes":"180x180","href":"\u002Fstatic\u002Ficon\u002Fapple-touch-icon-180x180.png"}],"script":[{"src":"https:\u002F\u002Fsecurepubads.g.doubleclick.net\u002Ftag\u002Fjs\u002Fgpt.js"},{"key":"newrelic","src":"\u002Fstatic\u002Fnewrelic\u002Fnewrelic.js","defer":true,"type":"text\u002Fjavascript"},{"key":"newrelic","src":"\u002Fstatic\u002Fnewrelic\u002Fnewrelic.js","defer":true,"type":"text\u002Fjavascript"},{"src":"https:\u002F\u002Fjs.fincode.jp\u002Fv1\u002Ffincode.js","defer":true},{"hid":"gtm-script","innerHTML":"if(!window._gtm_init){window._gtm_init=1;(function(w,n,d,m,e,p){w[d]=(w[d]==1||n[d]=='yes'||n[d]==1||n[m]==1||(w[e]&&w[e][p]&&w[e][p]()))?1:0})(window,navigator,'doNotTrack','msDoNotTrack','external','msTrackingProtectionEnabled');(function(w,d,s,l,x,y){w[x]={};w._gtm_inject=function(i){if(w.doNotTrack||w[x][i])return;w[x][i]=1;w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.async=true;j.src='https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id='+i;f.parentNode.insertBefore(j,f);};w[y]('GTM-5MZV9TS')})(window,document,'script','dataLayer','_gtm_ids','_gtm_inject')}"}],"style":[],"noscript":[{"hid":"gtm-noscript","pbody":true,"innerHTML":"\u003Ciframe src=\"https:\u002F\u002Fwww.googletagmanager.com\u002Fns.html?id=GTM-5MZV9TS&\" height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\" title=\"gtm\"\u003E\u003C\u002Fiframe\u003E"}],"__dangerouslyDisableSanitizersByTagID":{"gtm-script":["innerHTML"],"gtm-noscript":["innerHTML"]}},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_gtm_dbd73ac8 === 'function') {
    await nuxt_plugin_gtm_dbd73ac8(app.context, inject)
  }

  if (typeof nuxt_plugin_router_2faddbae === 'function') {
    await nuxt_plugin_router_2faddbae(app.context, inject)
  }

  if (typeof nuxt_plugin_polyfill_154da826 === 'function') {
    await nuxt_plugin_polyfill_154da826(app.context, inject)
  }

  if (typeof nuxt_plugin_common_721d56fc === 'function') {
    await nuxt_plugin_common_721d56fc(app.context, inject)
  }

  if (typeof nuxt_plugin_kernel_575d119a === 'function') {
    await nuxt_plugin_kernel_575d119a(app.context, inject)
  }

  if (typeof nuxt_plugin_injector_03ffdcaa === 'function') {
    await nuxt_plugin_injector_03ffdcaa(app.context, inject)
  }

  if (typeof nuxt_plugin_dataStream_530df880 === 'function') {
    await nuxt_plugin_dataStream_530df880(app.context, inject)
  }

  if (typeof nuxt_plugin_userAgent_fb3d1178 === 'function') {
    await nuxt_plugin_userAgent_fb3d1178(app.context, inject)
  }

  if (typeof nuxt_plugin_adManager_7292b158 === 'function') {
    await nuxt_plugin_adManager_7292b158(app.context, inject)
  }

  if (typeof nuxt_plugin_vueScrollto_46a09977 === 'function') {
    await nuxt_plugin_vueScrollto_46a09977(app.context, inject)
  }

  if (typeof nuxt_plugin_userinsight_d7933d94 === 'function') {
    await nuxt_plugin_userinsight_d7933d94(app.context, inject)
  }

  if (typeof nuxt_plugin_revisionCheck_6bb7fb76 === 'function') {
    await nuxt_plugin_revisionCheck_6bb7fb76(app.context, inject)
  }

  if (typeof nuxt_plugin_snapSlider_11929541 === 'function') {
    await nuxt_plugin_snapSlider_11929541(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
